import { useMutation, useQueryClient } from '@tanstack/react-query';

import { setCampaignType } from '@/lib/apis';
import type { CampaignData } from '@/lib/types';
import { useCampaignErrorToast } from '@/hooks/useCampaignErrorToast';

/**
 * Set a campaign's type (#6381 chunk F: all campaigns). On external campaigns this
 * confirms the classifier's suggestion and, with structure imported, completes
 * adoption. Invalidates the campaign detail and list queries so the type label
 * updates everywhere (sidebar, settings, performance).
 */
export function useSetCampaignType(campaign: CampaignData) {
  const queryClient = useQueryClient();
  const campaignErrorToast = useCampaignErrorToast();

  return useMutation({
    mutationFn: (goal: string) => setCampaignType(campaign.id, goal),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['campaign'] });
      void queryClient.invalidateQueries({ queryKey: ['campaigns'] });
    },
    onError: (err) => {
      campaignErrorToast({
        title: "Couldn't update the campaign type",
        message: err instanceof Error ? err.message : undefined,
        campaign,
      });
    },
  });
}
